export const navbar = {
  NavBar: {
    background: "linear-gradient(92deg, #4D3F24 22.65%, #FFA800 93.27%)",
  },
  logo: {
    height: "3rem",
  },
  item: {
    smallscreen: {
      color: "white",
    },
  },
  MenuModal: {
    background: "linear-gradient(92deg, #4D3F24 22.65%, #FFA800 93.27%)",
  },
};
